import Vue from "vue";

export function listAllExpertMessageApi(params, success) {
    let url = "/admin/web/expertMessage/listAllExpertMessage";
    Vue.prototype.alexPost(url, params, success);
}



